import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import DetailedCustomerProfile from './DetailedCustomerProfile';
import Confirm from '../../confirm/Confirm';
import CustomerService from '../../../service/CustomerService';

class CustomerModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      open: false,
    };
  }

  showDetails(customer, show) {
    const { sendNavigationRequest, } = this.props;
    if (!customer || !show) {
      return null;
    }
    return (
      <DetailedCustomerProfile customer={customer} sendNavigationRequest={sendNavigationRequest} />
    );
  }

  handleShow() {
    this.setState({ show: true, });
  }

  handleClose() {
    this.setState({ show: false, });
  }

  handleClickOpen = () => {
    this.setState({ open: true, });
  };

  handleConfirmClose = () => {
    this.setState({ open: false, });
  };

  reset() {
    this.setState({
      status: null,
    });
  }

  submitPasswordReset(customer) {
    this.reset();
    this.setState({ isLoading: true, });
    CustomerService.resetPassword({
      username: customer.account.username.toLowerCase().trim(),
      appId: customer.customer.appsInUse[0].appId,
    })
      .then(() => {
        this.setState({
          status: (
            <Alert dismissible className="mt-2" variant="success">
              <Alert.Heading>Success!</Alert.Heading>
              <p>{`User ${customer.account.username} has been sent a password reset email`}</p>
            </Alert>
          ),
        });
      })
      .catch(() => {
        this.setState({
          status: (
            <Alert dismissible className="mt-2" variant="danger">
              <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
              <p>{`Unable to reset password for user ${customer.account.username}`}</p>
            </Alert>
          ),
        });
      })
      .finally(() => {
        this.handleConfirmClose();
        this.setState({ isLoading: false, });
      });
  }

  updateUsernameNavigationRequest(customerProfile) {
    const { sendNavigationRequest, } = this.props;
    sendNavigationRequest({
      key: 'Update Username',
      state: customerProfile,
    });
    this.handleClose();
  }

  removeUserNavigationRequest(customerProfile) {
    const { sendNavigationRequest, } = this.props;
    sendNavigationRequest({
      key: 'Remove User',
      state: customerProfile,
    });
    this.handleClose();
  }

  transactionSearchNavigationRequest(customerProfile) {
    const { sendNavigationRequest, } = this.props;
    sendNavigationRequest({
      key: 'Transaction Search',
      state: customerProfile,
    });
    this.handleClose();
  }

  scheduledTransactionSearchNavigationRequest(customerProfile) {
    const { sendNavigationRequest, } = this.props;
    sendNavigationRequest({
      key: 'Scheduled Transaction Search',
      state: customerProfile.id,
    });
    this.handleClose();
  }

  conversationSearchNavigationRequest(customerProfile) {
    const { sendNavigationRequest, } = this.props;
    sendNavigationRequest({
      key: 'Conversation Viewer',
      state: customerProfile,
    });
    this.handleClose();
  }

  managedPaySearchNavigationRequest(customerProfile) {
    const { sendNavigationRequest, } = this.props;
    sendNavigationRequest({
      key: 'Managed Pay',
      state: customerProfile.id,
    });
    this.handleClose();
  }

  autoPaySearchNavigationRequest(customerProfile) {
    const { sendNavigationRequest, } = this.props;
    sendNavigationRequest({
      key: 'Autopay',
      state: customerProfile,
    });
    this.handleClose();
  }

  render() {
    const {
      show, isLoading = false, open, status,
    } = this.state;
    const { customer, } = this.props;
    return (
      <>
        <div>
          <Button variant="primary" onClick={() => this.handleShow()}>
            Details
          </Button>
          <Modal show={show} onHide={() => this.handleClose()} size="xl">
            <Modal.Header closeButton>
              <Modal.Title>{customer.customer.id}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => this.updateUsernameNavigationRequest(customer.account)}
                >
                  Update Username
                </button>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => this.removeUserNavigationRequest(customer.account)}
                >
                  Remove User
                </button>

                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => this.transactionSearchNavigationRequest(customer.customer)}
                >
                  Transaction Search
                </button>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => this.scheduledTransactionSearchNavigationRequest(customer.customer)}
                >
                  Scheduled Transaction Search
                </button>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => this.conversationSearchNavigationRequest(customer.customer)}
                >
                  Conversation Viewer
                </button>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => this.managedPaySearchNavigationRequest(customer.customer)}
                >
                  Managed Pay Search
                </button>
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={() => this.autoPaySearchNavigationRequest(customer.customer)}
                >
                  Autopay Search
                </button>
                <hr />
              </div>
              {this.showDetails(customer, show)}
            </Modal.Body>
          </Modal>
          <div style={{ float: 'right', }}>
            <Button variant="primary" onClick={this.handleClickOpen}>
              Reset Password
            </Button>
            <Confirm
              isLoading={isLoading}
              title="Reset Password Confirmation"
              content="Are you sure you want to reset this user's password?"
              open={open}
              onClose={this.handleConfirmClose}
              onYes={() => this.submitPasswordReset(customer.account)}
              onNo={this.handleConfirmClose}
            />
          </div>
        </div>
        {status}
      </>
    );
  }
}

CustomerModal.propTypes = {
  customer: PropTypes.object.isRequired,
  sendNavigationRequest: PropTypes.func.isRequired,
};
export default CustomerModal;
